import { downloadTORFile, uploadBOQ } from "../pages/Service";
import { signOut } from "../utils/signOut";

export async function exportFormTOR(userID, uName, inputData) {
  const extension = inputData.tor.split(".").pop();
  const torFile = inputData.tor;

  // Download TOR master file from bucket (wha-bucket/tor-form)
  const dataForm = {
    filename: torFile,
  };
  var blob = null;
  await downloadTORFile(dataForm).then((res) => {
    const filename = torFile;
    blob = new Blob([res.data]);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var newBlobIE = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      return navigator.msSaveOrOpenBlob(newBlobIE, filename);
    }
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(function () {
      window.URL.revokeObjectURL(data);
    }, 100);
  });

  // Generate file name
  const excelName = genTORFileName(userID, extension);

  // Upload to Google Cloud Storage
  await uploadToGCS(blob, excelName, userID, uName);

  return excelName;
}

const uploadToGCS = async (file, fileName, uID, uName) => {
  var formData = new FormData();

  if (file) {
    formData.append("file", file);
    formData.append("fname", fileName);
    formData.append("user_id", uID);
    formData.append("uname", uName);
  }

  await uploadBOQ(formData).then((res) => {
    if (res && res.status === 200 && res.data.success === true) {
      // console.log("File uploaded successfully");
    } else if (res.status === 401) {
      signOut();
    } else {
      console.log(`Error uploadTOR:`, res);
      console.error("File upload failed");
    }
  });
};

// Generate exported file name as YYYYMMDDhhmmss
const genTORFileName = (userID, extFile) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  // return `${year}${month}${day}${hours}${minutes}${seconds}${userID}-TOR.xlsx`;
  return `${year}${month}${day}${hours}${minutes}${seconds}${userID}-TOR.${extFile}`;
};
